<template>
    <div class="relative h-full z-0 overflow-hidden">
        <div
            :class="{ 'slidenav-open': is_open }"
            class="slidenav lg:slidenav-hidden"
        >
            <nav class="slidenav-nav overflow-y-auto scrollbar-hidden bg-grey-darker">
                <on-escape :execute="close">
                    <slot name="nav" />
                </on-escape>
            </nav>

            <div class="overflow-y-scroll w-full scrolls-to-top">
                <slot
                    name="body"
                    :open="open"
                    :close="close"
                    :toggle="toggle"
                    :isOpen="is_open"
                />

                <div
                    class="slidenav-overlay z-30"
                    @click.prevent="is_open = false"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                is_open: false
            }
        },
        watch: {
            '$route' () {
                this.close()
            }
        },
        methods: {
            open () {
                this.is_open = true
            },
            close () {
                this.is_open = false
            },
            toggle () {
                this.is_open ? this.close() : this.open()
            }
        }
    }
</script>
